import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { OrderData } from '../order-history-sales.model';
import { OrderHistorySalesService } from '../order-history-sales.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details-sales.component.html',
  styleUrls: ['./order-details-sales.component.scss']
})
export class OrderDetailsSalesComponent implements OnInit {

  public orderId!: string;
  public orderData: Observable<OrderData>;
  public isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    public orderHistoryService: OrderHistorySalesService,
  ) {
    this.orderData = new Observable<OrderData>();
  }

  ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get('id')!;
    this.orderData = this.orderHistoryService
      .find(this.orderId)
      .pipe(
        finalize( () => this.isLoading = false),
      );
  }
}
